const showDisableAdsBlockWarning = () => {
  const warnings = document.querySelectorAll(".rsy-warning-wrapper");
  warnings.forEach((warning) => {
    // eslint-disable-next-line no-param-reassign
    warning.style.display = "block";
  });
};

const adBlockCheck = {
  // Домен взят из https://github1s.com/gorhill/uBlock/blob/master/docs/tests/hostname-pool.js
  // Также присутствует https://easylist-downloads.adblockplus.org/easylist.txt
  domain: "survey.g.doubleclick.net",
  protocol: "https",
  scriptId: "adblock-detection",
};

/**
 * Делает запрос к url, который AdBlock считает "плохим", если запрос фейлится,
 * значит AdBlock установлен и заблокировал его
 */
const detectAdsBlock = async () => {
  try {
    const { protocol, domain } = adBlockCheck;
    await fetch(`${protocol}://${domain}`, {
      cache: "no-store",
      method: "HEAD",
      mode: "no-cors",
      signal: AbortSignal.timeout(5000),
    });
    return false;
  } catch (e) {
    return true;
  }
};

const insertAdBlockerJsToHead = () => {
  const script = document.createElement("script");
  script.id = adBlockCheck.scriptId;
  script.type = "text/javascript";
  // Имя файла взято из https://easylist-downloads.adblockplus.org/easylist.txt
  script.src = "/js/flyad.js";
  script.onerror = () => showDisableAdsBlockWarning();
  document.head.appendChild(script);
};

const removeAdFromPage = (adElement = {}) => {
  // eslint-disable-next-line no-param-reassign
  adElement.style.display = "none";
  const parent = adElement.parentElement;
  if (parent && parent.classList.contains("rsy-common-wrapper")) {
    parent.style.display = "none";
  }
};

const observeAdContainerForEmptiness = ({ adsBlock, callbackOnEmpty }) => {
  const rsyContainer = adsBlock.querySelector(".rsy-block");
  const observer = new MutationObserver(() => {
    if (rsyContainer.innerHTML.trim() === "") {
      callbackOnEmpty();
    }
  });

  observer.observe(rsyContainer, {
    childList: true,
    subtree: true,
    characterData: true,
  });
};

document.addEventListener("DOMContentLoaded", async () => {
  insertAdBlockerJsToHead();

  const isAdsBlockDetected = await detectAdsBlock();
  if (isAdsBlockDetected) {
    showDisableAdsBlockWarning();
  }

  const bannerWrappers = document.querySelectorAll(".rsy-block-wrapper");

  bannerWrappers.forEach((banner) => {
    const format = banner.querySelector(".rsy-block");
    const blockId = format.getAttribute("data-banner-id");
    const containerId = format.getAttribute("data-container-id");

    window.yaContextCb.push(() => {
      // eslint-disable-next-line no-undef
      Ya.Context.AdvManager.render({
        async: true,
        blockId,
        statId: 9945295,
        onError: () => {
          // eslint-disable-next-line no-param-reassign
          removeAdFromPage(banner);
        },
        renderTo: `${window.portal.yandexRSYBannerPrefixId}${blockId}${containerId ?? ""}`,
        onRender: () => {
          observeAdContainerForEmptiness({
            adsBlock: banner,
            callbackOnEmpty: () => removeAdFromPage(banner),
          });
        },
      });
    });
  });
});
